
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage, ElMessageBox } from "element-plus"
import { CardVersion } from "@/store/modules/CardVersionModule"
import { CardLanguageOption } from "@/store/modules/CardLanguageModule"

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("版本列表", ["抽卡系统"])
      // 加载语系选项
      store.dispatch(Actions.GET_ALL_CARD_LANGUAGES).then(() => {
        languageOptions.value = store.getters.currentAllCardLanguages
      })
    })

    const store = useStore()
    const tableData = ref<CardVersion[]>([])
    const languageOptions = ref<CardLanguageOption[]>([])

    const formData = ref({
      name: '',
      card_language_id: '' as string | number
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    const query = () => {
      store
        .dispatch(Actions.GET_CARD_VERSION_LIST, { ...formData.value, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentCardVersionList
          page.value.totalResult = store.getters.currentCardVersionCount
        })
        .catch(() => {
          ElMessage.error('获取版本列表失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }

    const onReset = () => {
      formData.value = {
        name: '',
        card_language_id: ''
      }
      page.value.currentPage = 1
      query()
    }

    const onDelete = (row: CardVersion) => {
      ElMessageBox.confirm(
        `确定要删除版本「${row.name}」吗？`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          store
            .dispatch(Actions.DELETE_CARD_VERSION, row.id)
            .then((data: { success: boolean; error_msg?: string }) => {
              if (data.success) {
                ElMessage.success('删除成功')
                query()
              } else {
                ElMessage.error(data.error_msg || '删除失败')
              }
            })
            .catch(() => {
              ElMessage.error('删除失败')
            })
        })
        .catch(() => {
          // 取消删除
        })
    }

    return {
      tableData,
      formData,
      languageOptions,
      submitEvent,
      page,
      onPageChange,
      onReset,
      onDelete
    }
  },
})
